import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import ContactUs from '../components/Contact';
import ServicesCards from '../components/Services';
import Header from '../components/Header';

import { Link } from 'gatsby';

import ipad from '../assets/images/ipad.png';
//import ipad from '../assets/images/ipad.webp';

const IndexPage = () => (
  <Layout>
    <Header />

    <header className="masthead Parallax-filter-172">
      <div className="container d-flex h-100 align-items-center">
        <div className="mx-auto text-center text-top">
          {/*       <h1 className="mx-auto my-0 text-uppercase">{config.heading}</h1> */}
          <h1 title="Hyper Dynamo Web Design" className="mx-auto my-0 text-white">{config.heading}</h1>
          {/*  <h2 className="text-white-50 mx-auto mt-2 mb-5"> */}
          <h2 title="Web development and software solutions for every business." className="text-white mx-auto mt-2 mb-5">{config.subHeading}</h2>
          <Scroll type="id" element="about">
            <a href="#about" className="btn-about btn-about-primary">
              About
            </a>
          </Scroll>
        </div>
      </div>
    </header>
    <section id="about" className="about-section text-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h2 className="text-white mb-4">About Hyper Dynamo</h2>
            <p className="text-white font-weight-light text-left">
              For over 10 years Hyper Dynamo has provided effective web
              development solutions for every business designed to be unique, as
              they are. Because of this we offer development solutions that can
              be personally tailored to suit your needs. Our customers operate
              in many industry sectors including construction, non-profit,
              retail, and corporate.
              <br /> <br />
              Please see our <a className="static-link" href="#services">our services section</a> for
              more details on the type of work we provide or{' '}
              <a className="static-link" href="#contact">contact us</a> us for more with any questions
              as to how we can help you achive your business goals
            </p>
          </div>
        </div>
        <img src={ipad} title="ipad Displaying Hyper Dynamo LLC site" className="img-fluid" alt="ipad Displaying Hyper Dynamo LLC site" />
  {/*     <picture>
      <source title="ipad Displaying Hyper Dynamo LLC site" className="img-fluid" alt="ipad Displaying Hyper Dynamo LLC site" srcset="../assets/images/ipad.webp" type="image/webp">
      <source title="ipad Displaying Hyper Dynamo LLC site" className="img-fluid" alt="ipad Displaying Hyper Dynamo LLC site" srcset={ipad} type="image/jpeg" type="image/jpeg"></source>
      <img src={ipad}  title="ipad Displaying Hyper Dynamo LLC site" className="img-fluid" alt="ipad Displaying Hyper Dynamo LLC site"></img>
      </picture>*/}
      </div>
    </section> 

    {/* Start Our Services Section */}

    <section className="projects-section bg-light">
      <div className="our-services-bg">
        <div id="services" className="container">
          <ServicesCards></ServicesCards>
        </div>
      </div>
    </section>

   
    <ContactUs />
    <Footer />
  </Layout>
);

export default IndexPage;
